export const thongTinXuatHoaDon = {
  sections: {
    list: { title: '开票信息' },
  },
  fields: {
    customerId: '客户（ID）',
    customer: '客户',
    ten: '取税公司名',
    buyerName: '购买方名称',
    taxCode: '税号',
    invoiceAddress: '取税地址',
    invoiceProvince: '省/市',
    invoiceWard: '坊/社',
    soCCCD: '身份证号',
    soHoChieu: '护照号',
    invoiceEmail: '开票邮箱',
    invoicePhone: '公司电话',
    daiDienCongTy: '公司代表',
    chucVu: '职务',
    bankName: '银行名称',
    bankAccount: '账号',
    bankAccounts: '银行账号',
    bankAccountCount: '{count} 个账号',
    accountHolder: '户名',
    default: '默认账号',
    defaultCompany: '默认开票公司',
    defaultYes: '默认',
    defaultNo: '—',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    actions: '操作',
  },
  actions: {
    addStk: '添加账号',
    removeStk: '删除账号',
  },
  inline: {
    itemTitle: '开票公司',
  },
  filter: {
    searchPlaceholder: '公司名、税号或电话',
    customerPlaceholder: '搜索客户…',
    defaultAll: '全部',
    defaultYes: '仅默认公司',
    defaultNo: '非默认',
  },
  import: {
    failed: '导入失败',
    menu: {
      cty: '导入取税公司',
      taiKhoan: '导入银行账号',
      ctyTaiKhoan: '组合导入（公司 + 账号）',
    },
  },
  placeholders: {
    provinceEmpty: '— 选择省/市 —',
    wardEmpty: '— 选择坊/社 —',
    ten: '例如：ABC 有限公司',
    invoiceEmail: '例如：kuaiji@co.com; sales@co.com',
  },
  titles: {
    add: '添加开票公司',
    edit: '编辑开票公司',
  },
  messages: {
    noData: '暂无数据',
    loadError: '数据加载失败',
    invalidContext: 'URL 缺少有效的客户编号。',
    customerRequired: '请选择客户。',
    createSuccess: '已创建开票信息',
    updateSuccess: '已更新开票信息',
    deleteSuccess: '已删除开票信息',
    notFound: '未找到开票信息',
    confirmDelete: '删除开票信息「{name}」？',
    listSummary: '共 {count} 家开票公司',
  },
}
